import { gql } from '@apollo/client'
import type { CreateLogisticDocumentLinkArgs, DocumentLinkCreated } from '@ztechapps/common.contract'
import { useActionMutation } from '@ztechapps/common.hook'

const createLogisticDocumentLinkQuery = gql`
  mutation createLogisticDocumentLink($input: CreateLogisticDocumentLinkArgs!) {
    createLogisticDocumentLink(input: $input) {
      token
      expiresAt
    }
  }
`

export type UseCreateLogisticDocumentLinkResult = {
  /** Creates a new public packing-slip link for the logistic; the token is shown only in this result. */
  mint: (logisticId: string) => Promise<DocumentLinkCreated>
}

export const useCreateLogisticDocumentLink = (): UseCreateLogisticDocumentLinkResult => {
  const [createLink] = useActionMutation<DocumentLinkCreated, CreateLogisticDocumentLinkArgs>({
    query: createLogisticDocumentLinkQuery,
  })

  return { mint: (logisticId) => createLink({ logisticId }) }
}
